import type { Post } from '../types';

export interface PostLists {
  /** Galerie : TOUS les posts (les programmés gardent leur badge « Programmé »). */
  gallery: Post[];
  /** File d'attente : posts programmés dans le futur. */
  queue: Post[];
  /** Calendrier : posts ayant une date (programmée ou de publication). */
  dated: Post[];
}

/**
 * Répartit les posts chargés depuis l'API entre galerie, file et calendrier.
 *
 * Avant (prod 2026-09), la galerie excluait les posts programmés dans le futur :
 * un post programmé « disparaissait » de la galerie après un rechargement alors
 * qu'il était bien en base (`status=scheduled`). La galerie montre désormais
 * tout ; la file et le calendrier sont inchangés.
 */
export function splitLoadedPosts(posts: Post[], now: Date = new Date()): PostLists {
  return {
    gallery: posts,
    queue: posts.filter(p => p.scheduledDate && new Date(p.scheduledDate) >= now),
    dated: posts.filter(p => p.scheduledDate || p.publishedDate),
  };
}

/**
 * Concatène des listes de posts en supprimant les doublons par id (le premier
 * gagne). La galerie contenant aussi les posts programmés, `[...posts, ...queue]`
 * compterait ces posts deux fois.
 */
export function mergePostsById(...lists: Post[][]): Post[] {
  const seen = new Set<string>();
  const merged: Post[] = [];
  for (const list of lists) {
    for (const post of list) {
      if (seen.has(post.id)) continue;
      seen.add(post.id);
      merged.push(post);
    }
  }
  return merged;
}
